// 📁 src/components/DiagnosticFeedbackBubble.jsx
import React from 'react';
import clsx from 'clsx';
import { marked } from 'marked';
import * as LucideIcons from "lucide-react";

const Icon = ({ name, size = 16, className = "" }) => {
    const LucideIcon = LucideIcons[name];
    return LucideIcon ? <LucideIcon size={size} className={clsx("stroke-[1.5]", className)} /> : null;
};

const DiagnosticFeedbackBubble = ({ content, opciones, onOptionClick, isProcessing }) => {
    if (!content) return null; // Guardia de seguridad
    
    // El 'content' para este tipo de burbuja también es un objeto
    const { titulo, texto, resumen } = (typeof content === 'string') ? JSON.parse(content || '{}') : (content || {});

    return (
        <div className={clsx('p-4 rounded-xl shadow-md self-start rounded-tl-none mb-4 w-full text-white bg-gradient-to-br from-purple-600 to-purple-800')}>
            <div className="flex flex-col space-y-3 w-full">
                <h3 className={clsx('text-lg font-bold flex items-center text-purple-200')}>
                    <Icon name="ClipboardCheck" /> 
                    <span className="ml-2">{titulo || "Resumen de Diagnóstico"}</span>
                </h3>
                {texto && <div className="text-sm text-gray-100" dangerouslySetInnerHTML={{ __html: marked.parse(texto) }} />}
                
                {/* Aquí podrías añadir lógica para mostrar el 'resumen' si existe */}

                <div className="flex items-center justify-center gap-4 w-full pt-3 mt-2">
                    {opciones && opciones.map((opcion, index) => (
                        <button
                            key={index}
                            onClick={() => onOptionClick(opcion)}
                            disabled={isProcessing}
                            className="flex items-center justify-center px-4 py-2 bg-white/90 text-gray-800 rounded-full hover:bg-white transition-colors duration-200 shadow-lg disabled:opacity-50"
                        >
                            <Icon name={opcion.icono || 'HelpCircle'} size={16} className="mr-2" />
                            <span className="font-semibold">{opcion.etiqueta}</span>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default DiagnosticFeedbackBubble;